import { BankOutlined, CreditCardOutlined } from '@ant-design/icons';

const carteiras = {
  id: 'group-carteiras',
  title: 'Carteiras',
  type: 'group',
  children: [
    {
      id: 'carteiras-collapse',
      title: 'Carteiras',
      type: 'collapse',
      icon: BankOutlined,
      children: [
        {
          id: 'cartoes-cadastrados',
          title: 'Cartões Cadastrados',
          type: 'item',
          url: '/carteiras/cartoes',
          icon: CreditCardOutlined,
          breadcrumbs: false
        }
      ]
    }
  ]
};

export default carteiras;
